import React, { useEffect, useState } from "react";
import { IStudentCurrentOpeningDetail } from "../../../../models/student/studentCareerPath";
import { connect } from "react-redux";
import { getJobDescription, getStudentCurrentOpeningDetails } from "../../../../action/student/studentCareerPathActionCreator";
import ReactPaginate from "react-paginate";
import { apiConfig } from "../../../../constants/apiConfig";
import LoaderSpinner from "../../../../common-components/loader";
import { getStudentInfoDetails } from "../../../../action/student/studentInfoActionCreator";

const CurrentOpenings = (props: IStudentCurrentOpeningDetail) => {
  const { currentOpenings, getStudentCurrentOpenings, userInfo, getStudentInfoDetails, programOfStudy, getJobDescription, jobDescription } = props;
  const [keyword, setKeyword] = useState<string | undefined>(undefined);
  const [paginationNumber, setPaginationNumber] = useState<number>(0)
  const [selectedPage, setSelectedPage] = useState<number>(1);
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const pageSize = 8;
  const oneturl = apiConfig.onetserviceurl;

  const onChange = (
    event:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
      | React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    const { value } = event.target;
    setKeyword(value || undefined);
  };

  const handleKeyDown = (event: any) => {
    if (event.key === 'Enter') {
      onSubmit();
    }
  };

  useEffect(() => {
    userInfo && getStudentInfoDetails(userInfo?.id);
    return () => {
      setKeyword(undefined)
    }
  }, [])

  const onSubmit = () => {
    if (userInfo) {
      const searchKeyword = keyword !== undefined ? keyword : undefined;
      setSelectedPage(1)
      getCurrentOpenings(selectedPage, searchKeyword)
    }
  }

  const handlePageClick = (pageNumber: any) => {
    const newPage = pageNumber.selected + 1;
    setSelectedPage(newPage);
  };

  useEffect(() => {
    if (currentOpenings) {
      setPaginationNumber(currentOpenings.total / pageSize);
      keyword === undefined && setKeyword(currentOpenings?.keyword);
      currentOpenings.occupation.map((data: any) => {
        if (jobDescription?.find((item) => item.code === String(data.code))) {
          return null;
        }
        return getJobDescription(String(data.code));
      });
    }
  }, [currentOpenings])

  useEffect(() => {
    setKeyword(programOfStudy)
    programOfStudy && getCurrentOpenings(selectedPage, programOfStudy);
  }, [selectedPage, programOfStudy]);


  const getCurrentOpenings = async (pageNumber: number, keyword?: string) => {
    setIsLoading(true)
    try {
      await getStudentCurrentOpenings(pageNumber, keyword);
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <div className="jobwrap mt-3">
        <div className="title">
          <h2>Current Openings</h2>
          <div className="search w-25">
            <input
              type="text"
              className="w-100"
              placeholder="Program of study"
              onChange={onChange}
              value={keyword}
              onKeyDown={handleKeyDown}
              name={"Keyword"}
            />
            <button onClick={onSubmit}><i className="fa-solid fa-magnifying-glass"></i></button>
          </div>
        </div>
        <div className="row">
          {currentOpenings?.occupation && currentOpenings.occupation.length > 0 ? (
            currentOpenings.occupation.map((data) => (
              <>
                {(isLoading || currentOpenings === undefined) && (<LoaderSpinner />)}
                <div className="col-lg-6 mb-3" key={data.code}>
                  <div className="jobs-card">
                    <a href={oneturl && oneturl + data.code} target="_blank">
                    <div className="top">
                      <div className="img">
                        <img src="assets/images/onet.png" alt="" />
                      </div>
                      <div className="desc">
                        <h2>{data.title}</h2>
                        {/* <ul className="style-none d-flex flex-wrap info-data">
                          <li>{data.code}</li>
                          <li>{data.place}</li>
                        </ul> */}
                      </div>
                      <span>
                      <img
                        src="/assets/images/icon/arrow-right.svg"
                        alt="Arrow icon"
                      />
                    </span>
                    </div>
                    {/* <div className="desc">{jobDescription(data.code)}</div> */}
                    <div className="desc">
                      {jobDescription?.find((item) => item.code === String(data.code))?.description || ""}
                    </div>
                    {/* <div className="btm">
                      <div className="btn-flex justify-content-between align-items-center mt-3">
                        <div title="End Date">
                          { <i className="fa-regular fa-calendar"></i> }
                          { <span className="ms-2"> {data.validDate} </span> }
                        </div>
                        <a href={oneturl && oneturl + data.code} target="_blank" className="btn btn-small btn-primary">
                          View More
                        </a>
                      </div>
                    </div> */}
                    </a>
                  </div>
                </div>
              </>
            ))
          ) : (
            currentOpenings?.occupation?.length === 0 && (<p>No data found</p>)
          )}
        </div>

        <div className="pagination">
          {paginationNumber > 1 &&
            <ReactPaginate
              previousLabel={"←"}
              nextLabel={"→"}
              breakLabel={"..."}
              breakClassName={"break-me"}
              pageCount={
                paginationNumber
              }
              marginPagesDisplayed={1}
              pageRangeDisplayed={2}
              onPageChange={handlePageClick}
              containerClassName={"pagination"}
              activeClassName={"active"}
              forcePage={selectedPage - 1}
            />
          }
        </div>
      </div >
    </>
  );
};
const mapDispatchToProps = {
  getStudentCurrentOpenings: (
    pageNumber: number,
    keyword?: string,
  ) =>
    getStudentCurrentOpeningDetails(pageNumber, keyword),
  getStudentInfoDetails: (userId: string) => getStudentInfoDetails(userId),
  getJobDescription: (jobCode: string) => getJobDescription(jobCode)
};

function mapStateToProps(state: any) {
  return {
    userInfo: state.userDetails.userProfileData,
    currentOpenings: state.studentCurrentOpenings.currentOpeningDetail,
    programOfStudy: state.studentInfo.studentInfo?.studentProgram?.programOfStudy,
    jobDescription: state.studentCurrentOpenings.jobDescription
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CurrentOpenings);
